<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .background-section {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(13px);
    width: 100%;

    .background-section-header {
      @include mixins.body2();
      @include colors.color(primary_90);
      margin: 0;
      padding-left: utils.in_rem(17px);
      text-transform: uppercase;
    }

    .items-container {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(9.75px);
      width: 100%;

      .education-item {
        padding-left: utils.in_rem(17px);
      }
    }

    .no-data-wrapper {
      align-items: center;
      display: flex;
      justify-content: center;
      padding: utils.in_rem(24px) 0;
      width: 100%;

      .no-data-text {
        @include colors.color(textGrey);

        .no-data-header {
          text-align: center;
        }

        span {
          @include mixins.body2();
          text-align: center;
        }
      }
    }
  }
</style>

<script>
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import NoData from "@sourcewhale/shared/svelte-design-system/components/atoms/NoData.svelte";
  import EducationItem from "./EducationItem.svelte";

  let { education } = $props();
</script>

<div class="background-section">
  <h3 class="background-section-header">Education</h3>
  {#if education.length > 0}
    <div class="items-container">
      {#each education as edu (edu.startedAt + edu.school + edu.degree + edu.field)}
        <div class="education-item">
          <EducationItem education={edu} />
        </div>
      {/each}
    </div>
  {:else}
    <div class="no-data-wrapper">
      <NoData>
        <div slot="icons" class="icons">
          <IconScale
            backgroundColor="interfaceSwGrey_10"
            color="interfaceSwGrey_20"
            class="fa-solid fa-graduation-cap"
            size="xl"
          />
        </div>
        <div slot="text" class="no-data-text">
          <h3 class="no-data-header">No education available</h3>
          <span>This contact has no education history</span>
        </div>
      </NoData>
    </div>
  {/if}
</div>
